import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Company Info */}
          <div>
            <h3 className="font-bold text-xl mb-4 flex items-center gap-2">
              <Heart className="w-5 h-5 text-red-500" />
              Desi Pet Recipes
            </h3>
            <p className="text-gray-300 text-sm mb-4">
              Personalized nutrition plans for your beloved pets. AAFCO-compliant, scientifically balanced, made with love.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/pets" className="text-gray-300 hover:text-white transition-colors">
                  My Pets
                </Link>
              </li>
              <li>
                <Link to="/special-diets" className="text-gray-300 hover:text-white transition-colors">
                  Special Diets
                </Link>
              </li>
              <li>
                <Link to="/recipe-book" className="text-gray-300 hover:text-white transition-colors">
                  50 Recipe Book
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Legal */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact & Legal</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2 text-gray-300">
                <Mail className="w-4 h-4" />
                <a href="mailto:aaglobal2023@gmail.com" className="hover:text-white transition-colors">
                  aaglobal2023@gmail.com
                </a>
              </div>
              <div className="pt-3 space-y-2">
                <Link 
                  to="/terms" 
                  className="block text-gray-300 hover:text-white transition-colors"
                >
                  Terms of Service
                </Link>
                <Link 
                  to="/privacy-policy" 
                  className="block text-gray-300 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-6">
          {/* Copyright & Protection Notice */}
          <div className="bg-gray-800 rounded-lg p-4 mb-4">
            <div className="flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-gray-300">
              <div className="text-center md:text-left">
                <p className="font-semibold text-white mb-1">© {new Date().getFullYear()} Desi Pet Recipes by AA Global Enterprises</p>
                <p className="text-gray-400">All rights reserved. Content, recipes and algorithms are copyright-protected intellectual property.</p>
              </div>
              <div className="bg-orange-900 border border-orange-700 rounded px-3 py-2 text-center">
                <p className="text-orange-200 font-medium">
                  ⚖️ The Pet Nutrition Engine, Ghost Mode and Kibble Calculator are proprietary systems protected by copyright.
                  Unauthorized copying, scraping, reverse-engineering or commercial use is strictly prohibited and may result in legal action.
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            {/* Medical Disclaimer */}
            <div className="bg-red-900 border border-red-700 rounded px-3 py-2 text-center max-w-md">
              <p className="text-red-200 text-xs font-medium">
                🏥 Medical Disclaimer: This app provides informational content only. Always consult a veterinarian before making dietary changes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;